import ActionItem from './ActionItem.jsx';
import QuizItem from './QuizItem.jsx';
import SurveyItem from './SurveyItem/SurveyItem.jsx';
import QnAItem from './QnAItem.jsx';

import { ACTION, QUIZ, SURVEY, QA } from '../../utils/constants';

const InteractionItemSelected = ({ type, option }) => {
  switch (type) {
    case ACTION:
      return <ActionItem option={option} />;
    case QUIZ:
      return <QuizItem option={option} />;
    case SURVEY:
      return <SurveyItem option={option} />;
    case QA:
      return <QnAItem />;
  }
};

export default InteractionItemSelected;
